import noneRuntime_36xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"none"} */
  provider: "none",
  providers: {
      ['none']: { setup: noneRuntime_36xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU, defaults: {} }
  }
}
